import { render } from "./BulkReceipts.vue?vue&type=template&id=1c4bb6e8&scoped=true"
import script from "./BulkReceipts.vue?vue&type=script&lang=js"
export * from "./BulkReceipts.vue?vue&type=script&lang=js"

import "./BulkReceipts.vue?vue&type=style&index=0&id=1c4bb6e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4bb6e8"]])

export default __exports__